import { render, staticRenderFns } from "./gallery-card-haines.vue?vue&type=template&id=15db632d&scoped=true&"
import script from "./gallery-card-haines.vue?vue&type=script&lang=js&"
export * from "./gallery-card-haines.vue?vue&type=script&lang=js&"
import style0 from "./gallery-card-haines.vue?vue&type=style&index=0&id=15db632d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db632d",
  null
  
)

export default component.exports